import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
declare var Dropbox: any;
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class DropboxService {
    options = {
  
      // Required. Called when a user selects an item in the Chooser.
      success: (files: any) => {
        //this.successDropbox(files);
        this.pickerCallback.successCallback(files);
      },
  
      // Optional. Called when the user closes the dialog without selecting a file
      // and does not include any parameters.
      cancel: () => {
        this.pickerCallback.cancelCallback()
      },
  
      // Optional. "preview" (default) is a preview link to the document for sharing,
      // "direct" is an expiring link to download the contents of the file. For more
      // information about link types, see Link types below.
      linkType: "direct", // or "direct"
  
      // Optional. A value of false (default) limits selection to a single file, while
      // true enables multiple file selection.
      multiselect: false, // or true
  
      // Optional. This is a list of file extensions. If specified, the user will
      // only be able to select files with these extensions. You may also specify
      // file types, such as "video" or "images" in the list. For more information,
      // see File types below. By default, all extensions are allowed.
      extensions: ['.pdf', '.doc', '.docx'],
  
      // Optional. A value of false (default) limits selection to files,
      // while true allows the user to select both folders and files.
      // You cannot specify `linkType: "direct"` when using `folderselect: true`.
      folderselect: false, // or true
  
      // Optional. A limit on the size of each file that may be selected, in bytes.
      // If specified, the user will only be able to select files with size
      // less than or equal to this limit.
      // For the purposes of this option, folders have size zero.
      sizeLimit: 22000000, // or any positive number
    };
    pickerCallback: any;
    constructor(private sharedService: SharedService) { }
  
    public open(data: any): void {
      this.pickerCallback = data;
      this.openDropbox();
    }
    openDropbox() {
     // Dropbox.appKey = '83xtbdcka1jk6m8';
      Dropbox.appKey = environment.dropboxKey;
      Dropbox.choose(this.options);
    }
  }